import FormValidations from './FormValidations';

export default class FormField extends FormValidations {
  /**
   * constructor description
   * @param {[String]} alias - An alias for this field
   * @param {[Number]} greaterThan - A number that field value need be bigger
   * @param {[Number]} greaterThanOrEqualTo - A number that field value need be bigger
   * @param {[Boolean]} cpf - True if need validate field using CPF rule
   * @param {[Boolean]} date - True if need validate field using Date rule
   * @param {[Boolean]} email - True for validates field as email
   * @param {[Array]} errors - Errors found after field validate
   * @param {[Boolean]} fullName - True for validates field as full name
   * @param {[Boolean]} aux - The function getRawValue will ignore this field
   * @param {[Number]} lowerThan - A number that field value need be lower
   * @param {[Number]} lowerThanOrEqualTo - A number that field value need be lower
   * @param {[String]} matchTo - A field name that this field value should be equal
   * @param {[Number]} maxLength - A number that field length need be lower
   * @param {[Number]} minLength - A number that field length need be bigger
   * @param {[Regex]} regex - A regex for validates field
   * @param {[Boolean]} required - True for validates field as required
   * @param {[Object]} ignoreIfNot - An object that contains { fieldName: value|Array of values } that will make form
   * not ignore this field when fieldname matchs the value
   * @param {[String]} getValueFrom - Get value from an specific field in the form
   * @param {[Any]} value - Any value for this field
   * @param {[Boolean]} zipCode - True for validates field as zip code
   * @param {[Boolean]} valid - Turns the field valid
   * @param {[Object]} requiredIfMatch - make the field required depending of another fields condition matchs
   * { fieldName: { value: value, condition: '><=!' }}
   * @param {[Array]} ignoredOnGetRawValueIfMatch - make the field ignored depending of another fields condition matchs
   * { fieldName: { value: value, condition: '><=!' }}
   * @param {[Object]} differentFrom - A object that contains a { alias: alias|String, value: value }, will validates
   * that the object value has to be differentFrom the hash value
   */
  constructor(params = {}) {
    super({
      value: params.value,
      maxLength: params.maxLength,
      minLength: params.minLength,
      greaterThan: params.greaterThan,
      greaterThanOrEqualTo: params.greaterThanOrEqualTo,
      lowerThan: params.lowerThan,
      lowerThanOrEqualTo: params.lowerThanOrEqualTo,
      regex: params.regex,
      cpf: params.cpf,
      date: params.date,
      email: params.email,
      fullName: params.fullName,
      zipCode: params.zipCode,
      differentFrom: params.differentFrom,
      maxAge: params.maxAge,
      minAge: params.minAge,
    });

    this.onlyLettersAndSpaces = params.onlyLettersAndSpaces;
    this.alias = params.alias;
    this.errors = params.errors || [];
    this.getValueFrom = params.getValueFrom;
    this.ignoreOnGetRawValue = params.ignoreOnGetRawValue;
    this.ignoreOnGetRawValueIfNot = params.ignoreOnGetRawValueIfNot;
    this.matchTo = params.matchTo;
    this.required = params.required;
    this.ignoreIfNot = params.ignoreIfNot;
    this.requiredIfMatch = params.requiredIfMatch;
    this.ignoredOnGetRawValueIfMatch = params.ignoredOnGetRawValueIfMatch;
    this.valid = params.valid;
    this.onAddValueReplicateTo = params.onAddValueReplicateTo;
  }

  validateField(hideErrors) {
    this.valid = true;
    this.errors = [];

    if (!this.required && this.empty()) {
      return this.valid;
    }

    if (this.required && this.empty()) {
      this.errors.push(this.requiredError());
    } else {
      if (this.differentFrom && !this.validateDifferentFrom()) {
        this.errors.push(this.differentFromError(this.differentFrom.alias));
      }

      if (this.cpf && !this.validateCpf()) {
        this.errors.push(this.cpfError());
      }

      if ((this.maxLength || this.maxLength === 0) && !this.validateMaxLength()) {
        this.errors.push(this.maxLengthError(this.maxLength));
      }

      if ((this.minLength || this.minLength === 0) && !this.validateMinLength()) {
        this.errors.push(this.minLengthError(this.minLength));
      }

      if ((this.greaterThan || this.greaterThan === 0) && !this.validateGreaterThan()) {
        this.errors.push(this.greaterThanError(this.greaterThan));
      }

      if ((this.greaterThanOrEqualTo || this.greaterThanOrEqualTo === 0) && !this.validateGreaterThanOrEqualTo()) {
        this.errors.push(this.greaterThanOrEqualToError(this.greaterThanOrEqualTo));
      }

      if ((this.lowerThan || this.lowerThan === 0) && !this.validateLowerThan()) {
        this.errors.push(this.lowerThanError(this.lowerThan));
      }

      if ((this.lowerThanOrEqualTo || this.lowerThanOrEqualTo === 0) && !this.validateLowerThanOrEqualTo()) {
        this.errors.push(this.lowerThanOrEqualToError(this.lowerThanOrEqualTo));
      }

      if (this.email && !this.validateEmail()) {
        this.errors.push(this.emailError());
      }

      if (this.date && !this.validateDate()) {
        this.errors.push(this.dateError());
      }

      if (this.maxAge && !this.validateMaxAge()) {
        this.errors.push(this.maxAgeError(this.maxAge));
      }

      if (this.minAge && !this.validateMinAge()) {
        this.errors.push(this.minAgeError(this.minAge));
      }

      if (this.zipCode && !this.validateZipCode()) {
        this.errors.push(this.zipCodeError());
      }

      if (this.fullName && !this.validateFullName()) {
        this.errors.push(this.fullNameError());
      }

      if (this.regex && !this.validateRegex()) {
        this.errors.push(this.invalidValueError());
      }

      if (this.onlyLettersAndSpaces && !this.validateOnlyLettersAndSpaces()) {
        this.errors.push(this.onlyLettersAndSpacesError());
      }
    }

    this.valid = this.errors.length === 0;

    if (hideErrors) {
      this.errors = [];
    }

    return this.valid;
  }

  empty() {
    return this.value === null || this.value === '' || this.value === undefined || this.value.length === 0;
  }
}
